<script lang="tsx">
import { defineComponent, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { Table, type TableColumnType } from 'ant-design-vue'
import { genHouseDemolitionStandardDataSource } from '../../tools'
const [name] = createNamespace('HouseDemolitionCompStandardDisplay')
export default defineComponent({
  name,
  props: {
    data: {
      type: Object as PropType<Partial<ApiJtProj.CompStandardData>>,
      default: () => ({})
    }
  },
  setup(props) {
    const columns: TableColumnType[] = [
      {
        title: '类别',
        dataIndex: 'type',
        width: 300,
        customRender({ text }) {
          return <span innerHTML={text}></span>
        }
      },
      {
        title: '单位',
        dataIndex: 'unit',
        width: 50,
        customRender() {
          return '平方米'
        }
      },
      {
        title: '标准(元/单位)',
        dataIndex: 'standard',
        width: 100,
        customRender({ record }) {
          return props.data?.[record.key] ?? '-'
        }
      }
    ]
    const dataSource = genHouseDemolitionStandardDataSource(props.data)
    return () => <Table pagination={false} columns={columns} dataSource={dataSource} size='small' />
  }
})
</script>
